export default "__VITE_ASSET__DnrmU0Mi__"